<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on">Выбрать товары</v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Выбор товаров: {{ category.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="mt-7">
        <v-alert
          v-if="Boolean(error)"
          type="error"
          dense
          outlined
        >Исправьте ошибки ввода - кол-во должно быть целым числом.</v-alert>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            v-for="item of products"
            :key="item._id"
          >
            <v-card style="height:100%; display: flex; flex-direction: column;">
              <v-card-title style="line-height: 110%; word-break: normal; flex: 1 0 auto;">
                <material-card :product="item" v-model="item._value"></material-card>
              </v-card-title>
              <v-card-text>
                <div style="width: 200px; height: 200px;">
                  <img
                    v-if="item.photos.length > 0"
                    :src="item.photos[0].smallImagelUrl" 
                    style="max-width: 200px; max-height: 200px;"
                  >
                </div>
                <div style="text-align: center; font-weight: bold;">
                  {{ item.pricePerUnit }} &#8381; / {{ item.productUnitName }} 
                  <template v-if="item.unitName != item.productUnitName">
                    <br>
                    <small>
                      {{ (item.pricePerUnit / item.productUnitSize).toFixed(2) }} &#8381; / {{ item.unitName }}
                    </small>
                  </template>
                </div>
              </v-card-text>
              <v-card-actions>
                <material-value :product="item" v-model="item._value" class="ml-2 mb-2"></material-value>
                <div class="pa-2">
                  <strong>{{ (item._value * item.pricePerUnit).toFixed(0) }} &#8381;</strong>
                </div>
                
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="pl-2">
          Выбрано {{ productsCount }} товар(ов) 
          <template v-if="category.unitName != category.productUnitName">
            [{{ productUnitsCount }} {{ category.unitName }}]
          </template> 
          на сумму <strong>{{ productsCost }}</strong> &#8381;
        </div>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
   </v-dialog>
</template>

<script>
import MaterialCard from './ConstructorMaterialCard';
import MaterialValue from './ConstructorMaterialValue';

export default {
  props: {
    products: Array, // Массив товаров
    category: Object, // Объект категории
    price: Object, // Ссылка на прайс-лист
  },

  components: {
    MaterialCard,
    MaterialValue
  },

  data() {
    return {
      activeMode: false,
      isValid: false,
      error: false
    }
  },

  methods: {
    scrollUp() {
      let modals = document.getElementsByClassName('v-dialog--active');
      if (modals.length > 0) {
        let cards = modals[modals.length - 1].getElementsByClassName('v-card__text');
        if (cards.length > 0) {
          cards[0].scrollTop = 0;
        }
      }
    },

    save() {
      this.error = false;

      for (let val of this.products) {
        if (!this.isInteger(val._value)) {
          this.error = true;
          this.scrollUp();
          return;
        }
      }

      this.products.forEach(x => x.value = x._value);
      this.$emit('saved');
      this.closeForm();
    },

    closeForm() {
      this.scrollUp();
      this.activeMode = false;
      this.products.forEach(element => {
        element._value = element.value
      });
      this.error = false;
    },
  },

  computed: {
    productsCount() {
      return this.products.reduce((sum, cur) => sum + Number(cur._value), 0);
    },
    productsCost() {
      return this.products.reduce((sum, cur) => sum + Number(cur._value) * Number(cur.pricePerUnit), 0).toFixed(2);
    },
    productUnitsCount() {
      return this.products.reduce((sum, cur) => sum + Number(cur._value) * Number(cur.productUnitSize), 0).toFixed(2);
    }
  }
}
</script>